/**
 * NOURION Kopfleiste: Nacht-zu-Tag-Wechsel, Vollbild-Mobilmenue mit
 * gestaffeltem Einflug, Fokusfalle ueber Kopfleiste + Menue, gezaehltem
 * Scroll-Lock und Anfragelisten-Badge (liest nourion-cart-v2, lauscht auf
 * nourion:cart:changed und das storage-Event, oeffnet den Drawer per Event
 * nourion:cart:open).
 *
 * Reinitialisiert sich bei shopify:section:load (Theme-Editor rendert Sections
 * ohne Seiten-Reload neu). Globale Listener (Scroll, Tastatur, Klick-
 * Delegation) werden dabei nur EINMAL registriert (Idempotenz-Guard ueber
 * window.__nourionHeaderBooted); DOM-Abfragen laufen bei jedem Aufruf frisch
 * ueber querySelector, damit neu gerendertes Markup automatisch mitspielt.
 */
(function () {
  'use strict';

  var CART_KEY = 'nourion-cart-v2';
  var SCROLL_THRESHOLD = 40;

  // ── Gezaehlter Scroll-Lock, geteilt mit anderen Overlays (z. B. Anfrageliste) ──
  if (!window.NourionScrollLock) {
    var lockCount = 0;
    window.NourionScrollLock = {
      acquire: function () {
        lockCount += 1;
        if (lockCount === 1) document.body.style.overflow = 'hidden';
      },
      release: function () {
        lockCount = Math.max(0, lockCount - 1);
        if (lockCount === 0) document.body.style.overflow = '';
      }
    };
  }

  // ── Nacht zu Tag: nur auf der Startseite scrollabhaengig, sonst immer Tag ──
  function syncDayNav() {
    var header = document.querySelector('[data-nourion-header]');
    if (!header) return;
    if (header.getAttribute('data-nourion-home') !== 'true') return;
    var crossed = window.scrollY > SCROLL_THRESHOLD;
    if (crossed) {
      header.classList.add('k-nav--day');
      header.classList.remove('dark-scope');
    } else {
      header.classList.remove('k-nav--day');
      header.classList.add('dark-scope');
    }
  }

  function onScroll() {
    syncDayNav();
  }

  // ── Anfragelisten-Badge ─────────────────────────────────────────────────────
  function readCartCount() {
    try {
      var raw = window.localStorage.getItem(CART_KEY);
      if (!raw) return 0;
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return 0;
      var n = 0;
      for (var i = 0; i < parsed.length; i++) {
        var item = parsed[i];
        if (item && typeof item === 'object' && typeof item.qty === 'number' && isFinite(item.qty) && item.qty > 0) {
          n += item.qty;
        }
      }
      return n;
    } catch (e) {
      return 0;
    }
  }

  function updateCartBadge() {
    var count = readCartCount();
    var badges = document.querySelectorAll('[data-nourion-cart-badge]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = String(count);
      if (count > 0) badges[i].removeAttribute('hidden');
      else badges[i].setAttribute('hidden', '');
    }
    var buttons = document.querySelectorAll('[data-nourion-cart-open]');
    for (var j = 0; j < buttons.length; j++) {
      buttons[j].setAttribute('aria-label', 'Anfrageliste öffnen (' + count + ' Einträge)');
    }
  }

  // ── Vollbild-Mobilmenue ─────────────────────────────────────────────────
  function getMenu() { return document.querySelector('[data-nourion-mobile-menu]'); }
  function getToggle() { return document.querySelector('[data-nourion-menu-toggle]'); }

  function setToggleIcon(open) {
    var toggle = getToggle();
    if (!toggle) return;
    var menuIcon = toggle.querySelector('[data-nourion-icon-menu]');
    var closeIcon = toggle.querySelector('[data-nourion-icon-close]');
    if (menuIcon) menuIcon.hidden = open;
    if (closeIcon) closeIcon.hidden = !open;
    toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function isMenuOpen() {
    var menu = getMenu();
    return !!menu && menu.classList.contains('is-open');
  }

  function setBackgroundInert(active) {
    // Hintergrund fuer Screenreader und Tastatur stummschalten, solange das
    // Mobilmenue als Dialog offen ist (aria-modal braucht einen stummen Rest)
    var areas = [document.getElementById('MainContent'), document.getElementById('footer-group')];
    for (var i = 0; i < areas.length; i++) {
      var el = areas[i];
      if (!el) continue;
      if (active) el.setAttribute('inert', '');
      else el.removeAttribute('inert');
    }
  }

  function openMenu() {
    var menu = getMenu();
    if (!menu || menu.classList.contains('is-open')) return;
    menu.classList.add('is-open');
    setToggleIcon(true);
    window.NourionScrollLock.acquire();
    setBackgroundInert(true);
  }

  function closeMenu(returnFocus) {
    var menu = getMenu();
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    setToggleIcon(false);
    window.NourionScrollLock.release();
    setBackgroundInert(false);
    if (returnFocus) {
      var toggle = getToggle();
      if (toggle) toggle.focus();
    }
  }

  function toggleMenu() {
    if (isMenuOpen()) closeMenu(false);
    else openMenu();
  }

  function focusableElements(scope) {
    var nodes = scope.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el.hasAttribute('disabled') && el.offsetParent !== null) out.push(el);
    }
    return out;
  }

  function onKeydown(e) {
    if (!isMenuOpen()) return;
    if (e.key === 'Escape') {
      closeMenu(true);
      return;
    }
    if (e.key !== 'Tab') return;
    var header = document.querySelector('[data-nourion-header]');
    var menu = getMenu();
    var scopes = [];
    if (header) scopes.push(header);
    if (menu) scopes.push(menu);
    if (!scopes.length) return;

    var focusables = [];
    for (var i = 0; i < scopes.length; i++) {
      focusables = focusables.concat(focusableElements(scopes[i]));
    }
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = document.activeElement;
    var inside = false;
    for (var j = 0; j < scopes.length; j++) {
      if (scopes[j].contains(active)) { inside = true; break; }
    }

    if (e.shiftKey && (active === first || !inside)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !inside)) {
      e.preventDefault();
      first.focus();
    }
  }

  // ── Klick-Delegation (robust gegen shopify:section:load-Neurender) ────────
  function onDocumentClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var cartBtn = target.closest('[data-nourion-cart-open]');
    if (cartBtn) {
      document.dispatchEvent(new CustomEvent('nourion:cart:open', { bubbles: true }));
      return;
    }

    var toggleBtn = target.closest('[data-nourion-menu-toggle]');
    if (toggleBtn) {
      toggleMenu();
    }
  }

  function onCartOpenEvent() {
    // Oeffnet der Anfragelisten-Drawer ueber dem offenen Mobilmenue, schliesst
    // das Menue sofort: zwei aktive Fokusfallen wuerden sich sonst
    // gegenseitig den Fokus zuschieben. Die Kopfleiste bleibt klickbar.
    closeMenu(false);
  }

  function onCartChanged() { updateCartBadge(); }
  function onStorage(e) { if (e.key === CART_KEY) updateCartBadge(); }

  // ── Init / Reinit ──────────────────────────────────────────────────────
  function reinit() {
    syncDayNav();
    updateCartBadge();
    // Neu gerendertes Markup startet immer geschlossen, wie beim ersten Mount
    var menu = getMenu();
    if (menu) menu.classList.remove('is-open');
    setToggleIcon(false);
    setBackgroundInert(false);
  }

  function boot() {
    if (!window.__nourionHeaderBooted) {
      window.__nourionHeaderBooted = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      // Wechsel auf Desktop Breite bei offenem Mobilmenue: schliessen, sonst
      // blieben inert und Scroll Lock aktiv, waehrend Menue und Schliessknopf
      // per CSS unsichtbar sind (Seite waere unbedienbar, z. B. Tablet Drehung)
      var desktopQuery = window.matchMedia('(min-width: 1024px)');
      var onDesktopChange = function (e) { if (e.matches) closeMenu(false); };
      if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onDesktopChange);
      else if (desktopQuery.addListener) desktopQuery.addListener(onDesktopChange);
      window.addEventListener('keydown', onKeydown);
      document.addEventListener('click', onDocumentClick);
      document.addEventListener('nourion:cart:open', onCartOpenEvent);
      document.addEventListener('nourion:cart:changed', onCartChanged);
      window.addEventListener('storage', onStorage);
    }
    reinit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    reinit();
  });
})();
